import { useState } from 'react'
import { UserDataContext } from './Context';

export const UserDataProvider = ({ children }) => {
  const [userData, setUserData] = useState(() => {
    const storedData = localStorage.getItem('userData');
    if (!storedData || storedData === 'undefined') return {};
    try {
      return JSON.parse(storedData);
    } catch {
      // Если парс не удался — сбрасываем на {}
      return {};
    }
  });
  const updateUserData = (newData) => {
    setUserData(prev => {
      const actualData = typeof newData === 'function' ? newData(prev) : newData;
      localStorage.setItem('userData', JSON.stringify(actualData));
      return actualData;
    });
  };
  const clearUserData = () => {
    localStorage.removeItem('userData');
    setUserData({});
  };
  return (
    <UserDataContext.Provider value={{ userData, setUserData: updateUserData,clearUserData }}>
      {children}
    </UserDataContext.Provider>
  );
};
